import {
  ContextualMenu,
  DirectionalHint,
  IContextualMenuItem,
} from '@fluentui/react';
import { FC } from 'react';

interface EmailTrackingMenuProps {
  closeMenu: (open: boolean) => void;
  onEmailTrackingChange?: (trackClicks: boolean, trackOpens: boolean) => void;
  trackOpensChecked: boolean;
  trackClicksChecked: boolean;
}

const EmailTrackingMenu: FC<EmailTrackingMenuProps> = ({
  closeMenu,
  onEmailTrackingChange,
  trackClicksChecked,
  trackOpensChecked,
}) => {
  const menuItems: IContextualMenuItem[] = [
    {
      key: 'trackOpensAndClicks',
      text: 'Track opens and clicks',
      className: `${
        trackOpensChecked && trackClicksChecked ? 'bg-neutral/50' : ''
      }`,
      iconProps: {
        iconName: trackOpensChecked && trackClicksChecked ? 'checkmark' : '',
      },
      onClick: () => {
        if (onEmailTrackingChange) {
          onEmailTrackingChange(true, true);
        }
      },
    },
    {
      key: 'trackOpensOnly',
      text: 'Track opens only',
      className: `${
        trackOpensChecked && !trackClicksChecked ? 'bg-neutral/50' : ''
      }`,
      iconProps: {
        iconName: trackOpensChecked && !trackClicksChecked ? 'checkmark' : '',
      },
      onClick: () => {
        if (onEmailTrackingChange) {
          onEmailTrackingChange(false, true);
        }
      },
    },
    {
      key: 'doNotTrack',
      text: 'Do not track',
      className: `${
        !trackOpensChecked && !trackClicksChecked ? 'bg-neutral/50' : ''
      }`,
      iconProps: {
        iconName: !trackOpensChecked && !trackClicksChecked ? 'checkmark' : '',
      },
      onClick: () => {
        if (onEmailTrackingChange) {
          onEmailTrackingChange(false, false);
        }
      },
    },
  ];

  return (
    <ContextualMenu
      items={menuItems}
      onItemClick={() => closeMenu(false)}
      onDismiss={() => closeMenu(false)}
      directionalHint={DirectionalHint.bottomLeftEdge}
      target='[aria-label="Email Tracking"]'
    />
  );
};

export default EmailTrackingMenu;
